import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=ba984ab2&scoped=true"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"
import style0 from "./UserDocuments.vue?vue&type=style&index=0&id=ba984ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba984ab2",
  null
  
)

export default component.exports